import * as React from 'react';
import { useFiltersContext } from '../../contexts/filters';
import { ITaxonomy } from '../../types';

interface IProps {
	taxonomy: ITaxonomy;
}

interface ISelectOption {
	label: string;
	value: string;
}

const LargePills = ({ taxonomy }: IProps) => {
	let options = taxonomy.terms.map((term) => {
		// decode htmlentities.
		const label = document.createElement('textarea');
		label.innerHTML = term.name;

		return {
			label: label.value,
			value: '' + term.term_id,
		};
	});

	options = [{ label: `All`, value: '' }, ...options];

	const { selectedTax, selectTaxTerm } = useFiltersContext();

	let baseValue = options[0];
	if (selectedTax[taxonomy.name] && selectedTax[taxonomy.name].length) {
		const newBaseValue = options.find(
			(item) => item.value === selectedTax[taxonomy.name][0].toString()
		);
		if (newBaseValue) {
			baseValue = newBaseValue;
		}
	}
	const [value, setValue] = React.useState(baseValue);

	const prevValue = React.useRef(baseValue.value);
	const handleOnChange = (option: ISelectOption | null) => {
		if (null !== option && prevValue.current !== option.value && selectTaxTerm) {
			setValue(option);
			selectTaxTerm(taxonomy.name, +option.value);
			prevValue.current = option.value;
		}
	};

	// When filters are reset, set our value back to the first option.
	React.useEffect(() => {
		if (!Object.values(selectedTax).length) {
			setValue(baseValue);
			prevValue.current = '';
		}
	}, [selectedTax]);

	return (
		<div className="pfa-filter-large-pills">
			{options.map((option) => (
				<label
					key={option.value}
					className="pfa-filter-large-pills__label btn"
					htmlFor={`pfa-filter-large-pills-${taxonomy.name}-${option.value}`}
				>
					<input
						type="checkbox"
						id={`pfa-filter-large-pills-${taxonomy.name}-${option.value}`}
						value={option.value}
						className="pfa-filter-large-pills__input"
						checked={value.value === option.value}
						onChange={() => handleOnChange(option)}
					/>
					{option.label}
				</label>
			))}
		</div>
	);
};

LargePills.displayName = 'LargePills';

export default LargePills;
